export default "__VITE_ASSET__Cm$1yDCq__"